import * as Sentry from "@sentry/vue";
import { name, version } from "../package.json";
import Vue from "vue";
import App from "./views/Home.vue";
import store from "./standalone-store";

Vue.config.productionTip = false;

console.log("init");

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENVIRONMENT,
  release: `${name}@${version}`,
});

new Vue({
  store,
  render: (h) => h(App),
}).$mount("#app");
